import { render, staticRenderFns } from "./SingleGrid.vue?vue&type=template&id=05544190&scoped=true&"
import script from "./SingleGrid.vue?vue&type=script&lang=js&"
export * from "./SingleGrid.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05544190",
  null
  
)

export default component.exports